import React from 'react'
import Grid from '../layout/grid'
import "../template/dependencies";

export default props => { 

    let labelCol =  props.orientation === 'landscape' ? '6' : '4' 
    let formCol =  props.orientation === 'landscape' ? '5' : '7' 
    
    let labelClass = `col-md-${labelCol} col-sm-${labelCol} col-xs-${labelCol}` + (props.orientation === 'landscape' ? '' : ' nopadding')
    let selectClass = `col-md-${formCol} col-sm-${formCol} col-xs-${formCol}` + (props.orientation === 'landscape' ? ' nopadding' : '')

    return (
        <Grid cols={props.cols}>
            <div className='form-group'>
                <div className={labelClass} style={{float:'left'}}>
                    <label htmlFor={props.name} style={{float:'right', fontSize:'16px', marginTop:'10px'}}>{props.label}</label>
                </div>
                
                <div className={selectClass} style={{display:'flex'}}>
                    <select className="form-control" id={props.name} onChange={props.onChange} >
                        {props.children}
                    </select>
                </div>

                <div className='col-md-1 col-sm-1 col-xs-1 nopadding'>
                    <i className="fa fa-question-circle" style={{color:'#3c8dbc', fontSize:'22px', marginTop: '5px'}}></i>
                </div>
            </div>
        </Grid>)
}


// WEBPACK FOOTER //
// ./src/common/form/labelAndDropdown.jsx